import {
  INDRET_INICIALITZAR,
  OBTENIR_INDRETS,
  OBTENIR_INDRETS_LLISTAT,
  OBTENIR_DADES_INDRET
} from "../../actions/actionTypes";

const ESTAT_INICIAL = false;

const peticioEnCurs = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case INDRET_INICIALITZAR:
      return ESTAT_INICIAL;

    case `${OBTENIR_INDRETS}_EN_CURS`:
    case `${OBTENIR_INDRETS_LLISTAT}_EN_CURS`:
    case `${OBTENIR_DADES_INDRET}_EN_CURS`:
      return true;

    case `${OBTENIR_INDRETS}_SUCCESS`:
    case `${OBTENIR_INDRETS}_ERROR`:
    case `${OBTENIR_INDRETS_LLISTAT}_SUCCESS`:
    case `${OBTENIR_INDRETS_LLISTAT}_ERROR`:
    case `${OBTENIR_DADES_INDRET}_SUCCESS`:
    case `${OBTENIR_DADES_INDRET}_ERROR`:
      return false;

    default:
      return state;
  }
};

export default peticioEnCurs;

export const getPeticioEnCurs = state => state;
export const getPeticioError = state => state.error;
